import React from "react";
import { Card, CardContent } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const box = { border: "1px solid #dfe4e1", borderRadius: 16, boxShadow: "none" };
const number = value => Number(value || 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 });

function Metric({ label, value, note }) {
  return <Card style={box}><CardContent>
    <small style={{ color: "#718078", letterSpacing: ".12em" }}>{label.toUpperCase()}</small>
    <div style={{ fontSize: 27, fontWeight: 800, marginTop: 7 }}>{value}</div>
    {note && <small style={{ color: "#89938d" }}>{note}</small>}
  </CardContent></Card>;
}

export default function CallsDashboard({ data = {} }) {
  return <div style={{ display: "grid", gap: 10 }}>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(190px,1fr))", gap: 10 }}>
      <Metric label="Total de ligações" value={number(data.total)} />
      <Metric label="Taxa de atendimento" value={`${number(data.answerRate)}%`} note={`${number(data.answered)} atendidas`} />
      <Metric label="Duração média" value={`${number(data.averageDuration)}s`} />
      <Metric label="Recebidas" value={number(data.incoming)} />
      <Metric label="Realizadas" value={number(data.outgoing)} />
      <Metric label="Não atendidas" value={number(Math.max(0, (data.total || 0) - (data.answered || 0)))} />
      <Metric label="Contatos únicos" value={number(data.contacts)} />
    </div>
    <Card style={box}><CardContent><h2 style={{ fontSize: 16, marginTop: 0 }}>Ligações por dia</h2>
      {data.daily?.length ? <div style={{ width: "100%", height: 250 }}><ResponsiveContainer><BarChart data={data.daily}>
        <CartesianGrid strokeDasharray="2 4"/><XAxis dataKey="date" tick={{fontSize:9}}/><YAxis tick={{fontSize:9}}/>
        <Tooltip/><Bar dataKey="total" fill="#b9cbd0" radius={[3,3,0,0]}/><Bar dataKey="answered" fill="#078b59" radius={[3,3,0,0]}/>
      </BarChart></ResponsiveContainer></div> : <p>Nenhuma ligação no período.</p>}
    </CardContent></Card>
  </div>;
}
